import { useState, type ReactNode } from "react";
import { useArmConfirm } from "../hooks/use-arm-confirm";

/**
 * **Zwei-Klick-Bestätigung (statt `window.confirm`).** Der erste Klick färbt
 * den Knopf (`pf-btn--armed`) und schreibt die Rückfrage hinein, der zweite
 * führt aus. Ein Klick daneben oder fünf Sekunden nehmen sie zurück. Während
 * die Aktion läuft, ist der Knopf gesperrt.
 */
export function ConfirmButton({
  onConfirm, confirmLabel = "Wirklich?", className = "pf-btn", disabled = false, title, children,
}: {
  onConfirm: () => void | Promise<void>;
  confirmLabel?: string;
  className?: string;
  disabled?: boolean;
  title?: string;
  children: ReactNode;
}) {
  const [busy, setBusy] = useState(false);
  const { armed, ref, onClick } = useArmConfirm<HTMLButtonElement>(async () => {
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); }
  });
  return (
    <button
      ref={ref} type="button" className={armed ? `${className} pf-btn--armed` : className}
      disabled={disabled || busy} title={title} onClick={onClick}
    >{armed ? confirmLabel : children}</button>
  );
}
